<template>
  <v-list-tile @click='$emit("clicked", invoice)' :style="statusBorder" >
      <slot name='actionsBefore'></slot>
      <v-list-tile-content>
          <slot name='title' >
            <v-list-tile-title slot='tile-title' >
              <practitioner-faces
                v-if='invoice.practitioner_id'
                :size="16"
                tooltip-prefix='Created by '
                :practitioner-ids="[invoice.practitioner_id]" />
              <space-faces
                v-if='invoice.space_id'
                :size="16"
                :space-ids="[invoice.space_id]" />

              <v-icon v-if='invoice.encrypt_password' small color='info' :title='invoice.encrypt_password' >
                lock
              </v-icon>

              <span>{{invoice.title}}</span>
              <v-chip class='v-chip--x-small px-0 my-0' label outline > #{{invoice.id}}</v-chip>

              <v-chip v-if='withStatus'
                class='v-chip--x-small' :color="statusColor" text-color="white"
                style='padding:0px 5px;;margin:0px;float:right' label>{{invoice.status.toUpperCase()}}
              </v-chip>
            </v-list-tile-title>
          </slot>
          <slot name='sub-title' >
            <v-list-tile-sub-title >
              <v-layout row wrap>
                <!-- {{ $t('date') }}: {{dateformat(invoice.date, 'DD-MM-YYYY')}}.  -->
                <v-flex class='pa-0 ml-1' xs12 >
                  {{ $t('invoiceDate') }}: <strong>{{ dateformat(invoice.date, 'YYYY-MM-DD') }}</strong> /
                  {{ $t('dueDate') }}: <strong>{{ dateformat(invoice.due_date, 'YYYY-MM-DD') }}</strong>
                </v-flex>
                <v-flex class='pa-0 ml-1' >
                {{ $t('total') }}: <strong>{{ formatCurrency(invoice.currency, invoice.invoice_amount) }}</strong>
                </v-flex>
                <v-flex class='pa-0' >
                {{ $t('payments') }}: <strong>{{ formatCurrency(invoice.currency, invoice.amount_paid) }}</strong>
                </v-flex>
              </v-layout>
            </v-list-tile-sub-title>
          </slot>
      </v-list-tile-content>
      <!-- <v-divider vertical ></v-divider> -->
      <slot name='actionsAfter'>
      </slot>
  </v-list-tile>
</template>

<script>
import PractitionerFaces from '@/components/lists/PractitionerFaces.vue'
import SpaceFaces from '@/components/lists/SpaceFaces.vue'
export default {
  name: 'InvoiceListItem',
  components: {PractitionerFaces, SpaceFaces},
  props: {
    invoice: { type: Object, default: () => { return {} } },
    withStatus: { type: Boolean, default: false },
    withStatusBorder: { type: Boolean, default: false }
  },
  computed: {
    statusColor () {
      if (this.invoice) {
        if (this.invoice.status === 'paid') {
          return 'success'
        }
        if (this.invoice.status === 'sent') {
          return 'info'
        }
      }
      return 'blue-grey lighten-4'
    },
    statusBorder () {
      if (this.invoice && this.withStatusBorder) {
        let color = '#9E9E9E'
        if (this.invoice.status === 'paid') {
          color = '#4caf50'
        }
        if (this.invoice.status === 'sent') {
          color = '#2196f3'
        }
        return `border-left:solid 5px ${color};`
      }
      return null
    }
  },
  i18n: {
    messages: {
      en: {
        date: 'Date',
        dueDate: 'Due',
        invoiceDate: 'Date',
        total: 'Total',
        payments: 'Paid'
      }
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// InvoiceListItem.vue?5d396622